import extentOL from 'ol/extent';

export const centerOnFeatures = function(arrFeatures, map, padding){
	
	var extent = extentOL.createEmpty();
	
	for(var i = 0, len = arrFeatures.length; i < len; i++){
		extentOL.extend(extent, arrFeatures[i].getGeometry().getExtent());
	}
	
	//var pan = ol.animation.pan({duration: 500, source: map.getView().getCenter()})
	//var zoom = ol.animation.zoom({duration: 500, resolution: map.getView().getResolution()})
	//map.beforeRender(pan, zoom);
	
	map.getView().fit(extent, {padding: padding, duration: 500, easing: ol.easing.inAndOut});
	
	if(typeof callbackFunc != 'undefined'){
		callbackFunc(feature);
	}
}

export const isZoomGroupChanged = function(currentZoom, prevZoom, zoomGroups) {

    var cZoomIndx = null; //current zoom group index
    var pZoomIndx = null; //previous zoom index

    for (var i = zoomGroups.length - 1; i >= 0; i--) {
        var group = zoomGroups[i];

        if(group.indexOf(currentZoom) > -1) {
            cZoomIndx = i;
        }

        if(group.indexOf(prevZoom) > -1) {
            pZoomIndx = i;
        }
    }

    if(cZoomIndx === pZoomIndx) {
        return false;
    } else {
        return true;
    }
}

//check if not grouped. returns props if single, if not then false
export const getSingleFeatureProps = function(feature) {

	var props = feature.getProperties();

	if( Array.isArray( props.features)) {

		if( props.features.length === 1){
			return props.features[0].getProperties();
		} else {
			return false;
		}
	} else {

		return props;
	}
}

export const countProp = function(feature, propField, filterFunc = null) {

	var many = Array.isArray(propField);

	var count = 0;
	if(Array.isArray(feature)) {
		childFeatures = feature;
	} else {
		var childFeatures = feature.get('features');
	}
	
	if(typeof childFeatures !== 'undefined' && childFeatures.length > 0){
		for(var i = 0, len = childFeatures.length; i < len; i++){

			if(typeof childFeatures[i].getProperties !== 'undefined') {
				var props = childFeatures[i].getProperties();
			} else {
				var props = childFeatures[i];
			}
			

			if(many) {
				for (var n = propField.length - 1; n >= 0; n--) {
					if(props[propField[n]] === null) {
						continue;
					}
					count += parseInt(props[propField[n]]);
				}
			} else {
				if(props[propField] === null){
					continue;
				}
				count += parseInt(props[propField]);
			}
			
		
		}
	}else{
		var props = feature.getProperties();

		if(many) {
			for (var n = propField.length - 1; n >= 0; n--) {
				if(propField[n] === null){
					continue;
				}
				count += parseInt(props[propField[n]]);
			}
		} else {
			if(feature.getProperties()[propField] !== null){
				count += parseInt(props[propField]);
			}
		}
		
	}

	return count;
}

export const isLayerAdded = function(layer, mapref){

  var mapLayers = mapref.getLayers().getArray();

  for (var i = mapLayers.length - 1; i >= 0; i--) {
    if(mapLayers[i] === layer){
      return true;
    }
  }

  return false;
}


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/map/helpers.js